import { createAction } from '@reduxjs/toolkit';
import { requiredNonEmptyString, validatePayload, } from '../../utils/validate-payload.js';
import { searchParametersDefinition } from './search-parameter-schema.js';
export const restoreSearchParameters = createAction('searchParameters/restore', (payload) => validatePayload(payload, searchParametersDefinition));
/**
 * Restores a tab from the search parameters.
 * @deprecated This action will be removed in V4. Use alternative tab management methods instead.
 */
export const restoreTab = createAction('searchParameters/restoreTab', (payload) => validatePayload(payload, requiredNonEmptyString));
